/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(){
	if ($('#acc-reviews')){
		var activeClass = 'js-active';
		var trigger = $('.js-accordion').find('.js-accordion-trigger').first();
		var thisItem = trigger.attr('href');
		$(thisItem).addClass(activeClass).stop().slideDown();
		trigger.addClass(activeClass);
	}
});